import ContentLeft from './ContentLeft'

export default ContentLeft
